import { useState } from "react";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import OtpInput from "../../../components/OtpInput";
import { useAuth } from "../../../contexts/AuthContext";
import { useSelector } from "react-redux";

function SubscribeVerification() {
  const [otp, setOtp] = useState(""); // State to hold OTP value
  const { login, loggedIn } = useAuth();
  const sendOTPState = useSelector((state) => state.sendOTP);

  const handleOtpChange = (newOtp) => {
    setOtp(newOtp); // Update OTP value as user types
  };

  const handleSubmit = () => {};
  return (
    <div className="leap-pt-10">
      <div className="leap-text-white leap-flex leap-flex-col leap-gap-14 md:leap-gap-15 leap-scale-90">
        <div className="leap-flex leap-flex-col leap-gap-10  md:leap-gap-5 md:leap-flex-row leap-items-center md:leap-items-baseline leap-justify-center leap-px-2">
          <div className="leap-flex leap-gap-5 leap-items-center">
            <span className="leap-text-base">From </span>
            <span className="leap-text-[#73FAFD] leap-text-[36px]  sm:leap-text-[36px]  md:leap-text-[30px] lg:leap-text-[48px] xl:leap-text-[48px] leap-leading-[33px] leap-font-bold">
              February 9th
            </span>
          </div>
          <div className="leap-flex leap-gap-5 leap-items-center">
            <span className="leap-text-base"> To </span>
            <span className="leap-text-[#73FAFD] leap-text-[36px] sm:leap-text-[36px] md:leap-text-[30px] lg:leap-text-[48px] xl:leap-text-[48px] leap-leading-[33px] leap-font-bold">
              February 12th
            </span>
          </div>
        </div>
        <h1 className="leap-text-[16px] sm:leap-text-[33px] md:leap-text-[26px] xl:leap-text-[40px] leap-leading-[44px] leap-font-bold">
          Book Your Tour Now
        </h1>
      </div>
    </div>
  );
}

export default SubscribeVerification;
